import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TestingPlatformService {
  private currentToast: HTMLElement | null = null;

  constructor(private toastController: ToastController) {}

  /**
   * Muestra un toast indicando que esta es una plataforma de pruebas.
   * Solo se muestra cuando no está en producción.
   */
  async showTestingPlatformNotice(): Promise<void> {
    // Solo mostrar en modo no-producción
    if (environment.production) {
      return;
    }

    // Dismiss el toast anterior si existe
    if (this.currentToast) {
      this.currentToast.remove();
      this.currentToast = null;
    }

    const toast = await this.toastController.create({
      message: 'Esta plataforma es de pruebas',
      duration: 0, // No se auto-cierra
      position: 'top',
      color: 'warning',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel',
        },
      ],
    });

    await toast.present();
    this.currentToast = toast;
  }
}
